"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterableListService = void 0;
const tslib_1 = require("tslib");
const app_1 = require("app");
const webexUI_1 = require("webexUI");
const CountriesWithStates_1 = require("../Filters/CountriesWithStates");
class FilterableListService {
    static removeRedundantFilters(query) {
        const tempQueryArray = (0, webexUI_1.safe)(query.filter && query.filter.split(','));
        if (!tempQueryArray.length || !CountriesWithStates_1.mappedCountriesWithStates) {
            return tempQueryArray;
        }
        const indexOfCountryCode = (0, app_1.findIndex)(tempQueryArray, queryElement => queryElement.indexOf('countryCode:') === 0);
        const indexOfRegionCode = (0, app_1.findIndex)(tempQueryArray, queryElement => queryElement.indexOf('region:') === 0);
        if (indexOfCountryCode === -1 || indexOfRegionCode === -1) {
            return tempQueryArray;
        }
        if (CountriesWithStates_1.mappedCountriesWithStates.every(el => el !== tempQueryArray[indexOfCountryCode])) {
            tempQueryArray.splice(indexOfRegionCode, 1);
        }
        return tempQueryArray;
    }
    constructor(apiurl) {
        this.apiurl = apiurl;
        this.getData = (filters, pageProps, sort, pageSize, query, isInitialSearch) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const params = {
                filter: app_1.UrlService.CreateQueryCsv({
                    key: 'filter',
                    value: filters,
                }).value,
                page: pageProps.pageNumber + 1,
                pageSize,
                pageid: pageProps.pageid,
                query,
                sort,
                isInitialSearch,
            };
            if (!params.page) {
                delete params.page;
            }
            if (!params.filter) {
                delete params.filter;
            }
            if (!params.sort) {
                delete params.sort;
            }
            if (params.pageSize == null) {
                delete params.pageSize;
            }
            if (params.query == null || params.query.length === 0) {
                delete params.query;
            }
            const response = yield (0, app_1.api)(this.apiurl, params);
            return response.data;
        });
    }
}
exports.FilterableListService = FilterableListService;
FilterableListService.addFiltersToUrl = (filters, pageNumber, pageSize, sortBy, storeFiltersInHistory = false) => {
    const pageValue = pageNumber === -1 ? '' : (pageNumber + 1).toString();
    const pageSizeValue = pageSize !== null && pageSize !== void 0 ? pageSize : 10;
    const pageStatePushed = app_1.UrlService.AddToUrl({
        key: 'page',
        value: pageValue,
    }, false);
    app_1.UrlService.AddToUrl({
        key: 'pageSize',
        value: String(pageSizeValue),
    });
    app_1.UrlService.AddToUrl(app_1.UrlService.CreateQueryCsv({
        key: 'filter',
        value: filters,
    }), pageStatePushed || !storeFiltersInHistory);
    app_1.UrlService.AddToUrl({
        key: 'sort',
        value: sortBy,
    });
};
FilterableListService.getFiltersFromUrl = () => {
    const query = app_1.UrlService.GetObjectFromUrlString();
    const queryArray = FilterableListService.removeRedundantFilters(query);
    return {
        filters: queryArray,
        pageNumber: Number(query.page) - 1 || -1,
        pageSize: Number(query.pageSize),
        query: query.query,
        sortBy: query.sort || '',
        isInitialSearch: !!query.isInitialSearch,
    };
};
FilterableListService.getUrlFromFilters = (filters) => {
    const filter = filters && filters.length > 0
        ? app_1.UrlService.CreateQueryCsv({
            key: 'filter',
            value: filters,
        })
        : {};
    const urlObj = app_1.UrlService.CreateQueryObject([filter]);
    return app_1.UrlService.GetStringFromUrlObj(urlObj);
};
